import Vue from 'vue'

interface InputData {
  currentValue: string | number;
}

export default Vue.extend({
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data (): InputData {
    return {
      currentValue: ''
    }
  },
  watch: {
    value (newValue) {
      this.currentValue = newValue
    }
  },
  created () {
    this.currentValue = this.value
  },
  methods: {
    emitValue (value: string | number) {
      this.$emit('input', value)
    }
  }
})
